/* istanbul ignore file */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import get from 'lodash/get';
import List from 'yoda-core-components/lib/components/List/List';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import SlidePanel from 'yoda-site-components/lib/components/SlidePanel/SlidePanel';
import findAStorePageActions from 'yoda-site-components/lib/actions/FindAStorePageAction';
import FindStoresTabContainerLazy from 'yoda-site-components/lib/components/FindStores/components/FindStoresTabContainer/FindStoresLazy';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import { FIND_STORE_THEMES_PDP_MAJOR_APPLIANCES } from 'yoda-site-components/lib/common/Constants';
import Loading from 'yoda-site-components/lib/components/Loading/Loading';
import LoaderAction from 'yoda-site-components/lib/actions/LoadingAction';
import { initProductOptions } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import {
    selectPreferences,
    selectFeatureFlags,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import * as styles from './GeneralInformation.css';
import generalInfoConfig from './GeneralInformationConfig';
import { getIrisContent } from '../../actions/ProductContentAction';
import { openModalAnalytics } from '../../actions/AnalyticsAction';

const cx = classNames.bind(styles);
const prop65DefaultVerbiage = 'WARNING: Cancer and Reproductive Harm- www.P65Warnings.ca.gov';
function getGeneralInfo(GeneralInfo, AppliancesVanityNumber) {
    const generalInfoArr = [];
    // Generating new array of shipping tags that matches only the required config tags
    GeneralInfo.forEach((tag) => {
        let taginfo;
        taginfo = generalInfoConfig[tag];
        if (tag === 'needHelp') {
            const vanityCheck = { html: AppliancesVanityNumber };
            taginfo = { ...taginfo, ...vanityCheck };
        }
        generalInfoArr.push(taginfo);
    });
    return generalInfoArr;
}
class GeneralInformation extends Component {
    static defaultProps = {
        productContent: {},
        productDetails: {},
        dataAutomationId: ' ',
        actions: {},
        generalInfo: [],
        deliveryZipcode: '',
        findStoresDetails: {},
        deviceType: {},
        preferences: {},
        featureFlags: {},
    };

    static propTypes = {
        productContent: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        generalInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        findStoresDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        dataAutomationId: PropTypes.string,
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        deliveryZipcode: PropTypes.string,
        deviceType: PropTypes.objectOf(PropTypes.object).isRequired,
        preferences: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
    };

    constructor() {
        super();
        this.onFindStoresClosePanel = this.onFindStoresClosePanel.bind(this);
        this.findStoresPageData = this.findStoresPageData.bind(this);
        this.findMoreStoresPage = this.findMoreStoresPage.bind(this);
        this.state = {
            isModalOpen: false,
            isSlidePanelOpen: false,
            isSlidePanelOpenOnce: false,
        };
    }

    /* istanbul ignore next */
    componentWillReceiveProps(nextState) {
        if (this.state.isModalOpen) {
            if (nextState.productContent.body && nextState.productContent.body !== 'loading...') {
                this.props.actions.openModalAnalytics(nextState.productContent.title);
            }
        }
        if (!isEmpty(nextState.findStoresDetails)) {
            this.props.actions.removeLoader();
        }
    }

    onFindStoresClosePanel() {
        this.setState({ isSlidePanelOpen: false });
    }

    openModal(tagId, prop65Verbiage) {
        const { featureFlags, actions } = this.props;
        this.props.productContent.body = 'loading...';
        this.props.productContent.title = '';

        let prop65VerbiageContent;
        if (prop65Verbiage.length) {
            prop65VerbiageContent = `${prop65Verbiage}`;
        }
        let productContentTitle = null;
        let productContentBody = null;
        switch (tagId) {
            case 'disposal-fee':
                actions.getIrisContent(tagId);
                break;
            case 'recycle-fee':
                actions.getIrisContent(tagId);
                break;
            case 'prop65-warning-info':
                productContentTitle = 'Proposition 65';
                productContentBody = `<p> <strong> California Customers, </strong> </p>
                <br/>
                <p>
                <span>${prop65VerbiageContent}</span>
                </p>`;
                break;
            default:
                break;
        }
        this.setState({
            isModalOpen: true,
            productContentTitle,
            productContentBody,
        });
    }

    closeModal() {
        this.setState({ isModalOpen: false });
    }

    findStoresPageData(payload) {
        const storesPayload = {
            zipCode:
                payload && payload.zipCode ? payload.zipCode : this.props.findStoresDetails.zipCode,
            miles: payload && payload.miles ? payload.miles : this.props.findStoresDetails.miles,
            storeService: 'majorappliances',
            isPDPMajorAppliances: true,
        };
        this.props.actions.findStoresPage(storesPayload);
    }

    findMoreStoresPage() {
        const payload = {
            nextPageLink: this.props.findStoresDetails.nextPageLink,
        };
        this.props.actions.findMoreStoresPage(payload);
    }

    handleFindStores = () => {
        const { deliveryZipcode, actions } = this.props;
        this.setState({ isSlidePanelOpen: true });
        this.setState((prevState) => ({
            isSlidePanelOpenOnce: prevState.isSlidePanelOpenOnce
                ? prevState.isSlidePanelOpenOnce
                : true,
        }));
        actions.showLoader();
        actions.openModalAnalytics('find a store');
        if (deliveryZipcode) {
            const payload = {
                zipCode: deliveryZipcode,
                miles: 25,
                storeService: 'majorappliances',
                isPDPMajorAppliances: true,
            };
            actions.findStoresPage(payload);
        } else {
            actions.removeLoader();
        }
    };

    render() {
        const GeneralInfo = this.props.generalInfo;
        const { AppliancesVanityNumber } = this.props.preferences;
        const { productDetails } = this.props;
        let prop65Verbiage = prop65DefaultVerbiage.split(' ');
        if (productDetails && productDetails.lots) {
            const toFilter = new Set([true]);
            const productLotDefault = productDetails.lots.filter((obj) =>
                toFilter.has(obj.isDefault)
            );
            const prop65Values =
                productLotDefault &&
                productLotDefault.length &&
                productLotDefault[0].contextAttributes &&
                filter(productLotDefault[0].contextAttributes, { name: 'PROP65 VERBIAGE' });
            prop65Verbiage = get(prop65Values, '[0].values[0]', prop65DefaultVerbiage);
        }
        const renderGeneralInfoContent = (dataItem, index) => (
            <div data-automation-id="general-info-block">
                <div
                    className={dt(['flex', 'items-center'])}
                    data-automation-id="general-info--title-block"
                >
                    <span data-automation-id="general-info-icon" className={dt(['w-6', 'h-6'])}>
                        <Icon
                            iconType="svg"
                            width={dataItem.imgDimention}
                            height={dataItem.imgDimention}
                            viewBox="0 0 20 20"
                        >
                            {dataItem.iconComponent}
                        </Icon>
                    </span>
                    <div
                        data-automation-id="general-info-title"
                        className={dt([
                            'font-open-sans-semibold',
                            'text-base',
                            'leading-6',
                            'text-black',
                            'pl-2',
                        ])}
                    >
                        {dataItem.title}
                    </div>
                </div>
                <p data-automation-id="general-info-content" className={dt(['ml-8'])}>
                    <span
                        className={dt([
                            'pr-1',
                            'font-open-sans-regular',
                            'text-base',
                            'leading-6',
                            'text-black',
                        ])}
                    >
                        {dataItem.html}
                    </span>
                    {dataItem.link && !dataItem.href ? (
                        <Button
                            buttonType="Link"
                            className={dt(['sm:!font-normal', 'capitalize'])}
                            automationId={`${this.props.dataAutomationId}-${index}-link`}
                            aria-label={`link-${this.props.dataAutomationId}-${index}`}
                            onClick={() => this.openModal(dataItem.id, prop65Verbiage)}
                            size="btnSm"
                        >
                            {dataItem.link}
                        </Button>
                    ) : null}
                    {dataItem.findStoreLink ? (
                        <Button
                            buttonType="Link"
                            className={dt(['sm:!font-normal', 'capitalize'])}
                            automationId={`${this.props.dataAutomationId}-${index}-link`}
                            aria-label={`link-${this.props.dataAutomationId}-${index}`}
                            onClick={this.handleFindStores}
                            size="btnSm"
                        >
                            {dataItem.findStoreLink}
                        </Button>
                    ) : null}
                    {dataItem.href && dataItem.link ? (
                        <a
                            className={dt(['capitalize', 'underline'])}
                            data-automation-id={`${this.props.dataAutomationId}-${index}-link`}
                            aria-label={`link-${this.props.dataAutomationId}-${index}`}
                            href={dataItem.href}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {dataItem.link}
                        </a>
                    ) : null}
                </p>
            </div>
        );
        const generalInfoDataSource = getGeneralInfo(GeneralInfo, AppliancesVanityNumber);
        const title = 'Major Appliances';
        const pageHeader = cx('pageHeader');
        return (
            <div className={cx('GeneralInformationBlock')}>
                <div className={cx('GeneralInformationContainer')}>
                    {GeneralInfo && GeneralInfo.length ? (
                        <ErrorBoundary>
                            <List
                                childRenderer={renderGeneralInfoContent}
                                datasource={generalInfoDataSource}
                                direction="Vertical"
                                itemStyleClass={styles.tagsItem}
                                listStyleClass={styles.tagsList}
                                automationId={`${this.props.dataAutomationId}-List`}
                            />
                        </ErrorBoundary>
                    ) : null}
                </div>
                <ErrorBoundary>
                    <ModalBox
                        showModal={this.state.isModalOpen}
                        onClose={() => this.closeModal()}
                        defaultHeader
                        automationId="generalInformation-modal"
                        modalTheme={styles.customModalWrapper}
                        modalContentTheme={styles.pdpModalCustomContentHeight}
                    >
                        <div className={cx('GeneralInfoModalContainer')}>
                            <h3 className={styles.modalTitle}>
                                {this.state.productContentTitle
                                    ? this.state.productContentTitle
                                    : this.props.productContent.title}
                            </h3>
                            {/* eslint-disable react/no-danger */}
                            <div
                                className={cx('GeneralInfoModalContent')}
                                dangerouslySetInnerHTML={{
                                    __html: this.state.productContentBody
                                        ? this.state.productContentBody
                                        : this.props.productContent.body,
                                }}
                            />
                            <Button
                                buttonType="Primary"
                                type="button"
                                className={cx('GeneralInfoModalButton')}
                                onClick={() => this.closeModal()}
                            >
                                {' '}
                                OK{' '}
                            </Button>
                        </div>
                    </ModalBox>
                </ErrorBoundary>
                <ErrorBoundary>
                    {this.state.isSlidePanelOpenOnce ? (
                        <SlidePanel
                            isOpenPanel={this.state.isSlidePanelOpen}
                            onClosePanel={this.onFindStoresClosePanel}
                            panelTitle="Back"
                            hideContentScroll
                        >
                            <div>
                                <h2 className={pageHeader}> {title} </h2>
                                {this.state.isSlidePanelOpen && (
                                    <ErrorBoundary>
                                        <FindStoresTabContainerLazy
                                            findStoresDetails={this.props.findStoresDetails}
                                            theme={FIND_STORE_THEMES_PDP_MAJOR_APPLIANCES}
                                            findStoresAction={this.findStoresPageData}
                                            deviceType={this.props.deviceType}
                                            hideDirections={false}
                                            restrictMiles={false}
                                            findMoreStores={this.findMoreStoresPage}
                                            productDetails={null}
                                        />
                                    </ErrorBoundary>
                                )}
                            </div>
                        </SlidePanel>
                    ) : null}
                </ErrorBoundary>
                <Loading />
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    productContent: state.productContent || GeneralInformation.defaultProps.productContent,
    productOptions: initProductOptions(false)(state),
    productDetails: state.productDetails,
    deliveryZipcode: state.deliveryZipcode,
    findStoresDetails: state.findAStorePageInfo,
    deviceType: state.context
        ? state.context.deviceType
        : GeneralInformation.defaultProps.deviceType,
    preferences: selectPreferences(state),
    featureFlags: selectFeatureFlags(state),
});
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...findAStorePageActions,
            ...LoaderAction,
            openModalAnalytics,
            getIrisContent,
        },
        dispatch
    ),
});
export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation);
